
    var riot = require('riot')
    
riot.tag2('searchmap', '<div class="gmapdisplay"> <gmap name="markersearchmap" hidemarker="{true}" stylearray="{mapstyle}" riot-style="{\'height:\'+getHeight()+\'px\'}" postcode="{opts.query}" key="AIzaSyDi8XJj9OMCpanK0nMrncDayCK8oXMrUgw" class="watermap"></gmap> <gmap-markers markers="{page}" linkedmap="markersearchmap" onmarkerclick="{onmarkerclick}" lettermarkers="true"></gmap-markers><yield></yield> </div>', 'searchmap h1 { color: #fff; margin: 10px 0; font-size: 30px; } searchmap .btn.btn-primary { background: rgba(0,0,0,0.3); border-color: rgba(0,0,0,0.1); } searchmap:active:focus, searchmap .btn-primary:active:focus { background: rgba(0,0,0,0.4); border-color: rgba(0,0,0,0.2); outline: 0px; } searchmap .gmapdisplay { overflow: hidden; display: block; position: relative; } searchmap .searchForm { padding: 10px; display: block; } searchmap .searchForm .input-group-addon { background: #fff; padding-right: 0; } searchmap .searchForm .input-group-addon i { font-size: 20px; color: #3fa9f5; } searchmap .searchForm .form-control { border-left: 0; -webkit-box-shadow: none; box-shadow: none; } searchmap .searchForm button { border-color: #44009d; background-color: #44009d; } searchmap .watermap { display: block; height: 500px; } searchmap .overlay { position: absolute; top: 0; left: 0; background: rgba(255,255,255,0.5); padding: 15px; } searchmap .results { background: rgba(255,255,255,0.8); border: 1px solid #ccc; margin: 5px 0px; padding: 10px 15px; } searchmap .results h3 { margin: 5px 0 10px 0; } searchmap .popaddress h2 { margin: 0; } searchmap .popaddress h3 { font-size: 18px; margin: 15px 0 5px 0; color: #4b09a1; } searchmap .popaddress p { font-size: 14px; line-height: 18px; margin: 0; } searchmap .services { margin-bottom: 10px; } searchmap .services .checkbox { margin: 0; } searchmap .approved_background, searchmap ._background { background: #89a8e1; } searchmap .approved_background h4, searchmap ._background h4, searchmap .approved_background label, searchmap ._background label { color: #fff; } searchmap .approved_background.emergency, searchmap ._background.emergency { background: #d9534f; } searchmap .ltd_background { background: #00afcc; }', '', function(opts) {
var primary, secondary;

primary = "#d60b52";

secondary = "#00afcc";

this.mapstyle = [
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#444444"
      }
    ]
  }, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f2f2f2"
      }
    ]
  }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }, {
    "featureType": "poi.business",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [
      {
        "saturation": -100
      }, {
        "lightness": 45
      }
    ]
  }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "color": "#b4d4e1"
      }, {
        "visibility": "on"
      }
    ]
  }
];

this.on('mount', function() {
  this.searching = true;
  this.type = opts.type || 'approved';
  this.query = opts.query;
  window.addEventListener('resize', this.rescale);
  this.rescale();
  this.getGoogleRef();
  if (opts.query) {
    this.postcode = opts.query;
    this.update();
    return this.handlePage(opts.results);
  }
});

this.getHeight = (function(_this) {
  return function() {
    return document.querySelector(".results").offsetHeight + 50;
  };
})(this);

this.getGoogleRef = (function(_this) {
  return function() {
    var ref, ref1;
    if ((ref = window.google) != null ? (ref1 = ref.maps) != null ? ref1.event : void 0 : void 0) {
      _this.google = window.google;
      return _this.google.maps.event.addListenerOnce(_this.tags['markersearchmap'].map, 'idle', _this.updateMarkers.bind(_this, true));
    } else {
      return setTimeout((function() {
        return _this.getGoogleRef();
      }), 100);
    }
  };
})(this);

this.on('unmount', function() {
  return window.removeEventListener('resize', this.rescale);
});

this.rescale = (function(_this) {
  return function() {
    return _this.updateMarkers(true);
  };
})(this);

this.handlePage = (function(_this) {
  return function(page) {
    _this.page = page;
    _this.update();
    return _this.updateMarkers(true);
  };
})(this);

this.updateMarkers = (function(_this) {
  return function(force) {
    var map, ref, ref1, ref2, ref3, windowWidth;
    if (_this.page == null) {
      return;
    }
    if ((((ref = _this.page) != null ? (ref1 = ref[0]) != null ? ref1.id : void 0 : void 0) !== _this.oldFirstMarkerId || force) && (((ref2 = window.google) != null ? ref2.maps : void 0) != null)) {
      _this.tags['gmap-markers'].showMarkers();
      _this.tags['gmap-markers'].setZoom();
      windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
      map = _this.tags['markersearchmap'].map;
      if (_this.panning) {
        clearTimeout(_this.panning);
      }
      _this.panning = setTimeout(function() {
        if (windowWidth > 980) {
          return map.panBy(0 - windowWidth / 4, 0);
        }
      }, 500);
      map.setZoom(map.getZoom() - 1);
      _this.oldFirstMarkerId = (ref3 = _this.page[0]) != null ? ref3.id : void 0;
      return _this.update();
    }
  };
})(this);

this.onmarkerclick = (function(_this) {
  return function(selected) {
    _this.selected = selected;
    return _this.update();
  };
})(this);
});
    
  